module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "unnumbered-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_vm._v("So Burn Us Both")])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("LISSE KIRK")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "unnumbered-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-t"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("here is already ice in the mud, tiny crystals that bite through the delicate skin of my toes, stabs of warning.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Do you feel it? That sense of danger in the air, subtler and sharper even than the needles of ice? The sun is barely up, but something is already wrong with the day.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Humans carry their purpose with them when they go to carry out a task. Sometimes they’re bored with the job before they even begin it; that purpose is to hurry through it, or else to ignore it, choosing not to care. Humans are very good at the latter…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As are you, I sometimes think.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I worry about you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A team of men come into sight, bearing axes. Not an unusual sight, but I feel my skin tighten and my fur begin to stand on end.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sometimes, humans laugh as they go about certain tasks together—like cutting wood. It can be a great pleasure for them to work at tasks that will bring warmth to their families. Sometimes they find satisfaction in doing a job properly; a well-honed axe blade sinks deeply into a tree with each swing. Firewood is a need they all share. Even you, my beloved witch, need firewood. It is simple work. Clean work.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It is strange for there to be shame amongst woodcutters, Mother, but that is what I see now. Four men go out to the woods together, leaving the town behind. The autumn dawn is pale and cold and their breath makes great plumes that should make them laugh…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They do not laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They are silent.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They seem ashamed. Furtive. They avoid looking toward our home as they pass us by.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This is the last farm before the endless forest. You have grown a beautiful garden, lovely in all seasons, your pride and joy over all the years I have known you, all of my lives.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They should look at it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("People often come just to look.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("These men do not.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The ice in the mud is too cold. Pain radiates up through my too-thin body. My coat is not as thick as it once was. My muscles are not as strong. Leaping onto a fencepost is harder than it was, but thankfully the wood is old and soft and my claws, at least, are still sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sunlight reaches me up there, although it is not yet touching the ground. It warms me through my black fur. I sit atop the post and curl my tail around my paws, watching the men walk by until there is nothing left to see.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What shame can there be in cutting wood? Why is there warning in the air this morning? I remain very still, listening—not just to the world, but to the currents moving through it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There should be some hint of what tomorrow might bring…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The sun rises higher and brings no answers. Birds sing, but very few of them; most have already fled these northern lands. The sky believes this winter will be one of its finest accomplishments. I tried weeks ago to warn you of this, that we should flee like so many birds do every year, yet here we are.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ice in the mud.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shame in the eyes of woodcutters. Furtiveness in their walk.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Needles of warning.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("After the cold,")]), _vm._v(" it feels sweltering inside our home.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You did not always keep the cabin so warm.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I am pleased by the heat—it seeps into my bones as I sit as close to the fire as I dare—but you have changed. You usually want to stockpile wood, to use it sparingly, especially on these first cold days. You like to “get used to the cold” and adjust by adding layers of wool over your body until the wool doesn’t help you enough anymore and you tire of breaking ice in the water pitcher.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Do you think I don’t know this of you? Nearly eighty-one years together, you and I. Don’t you know it has always been me? Don’t you suspect?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Don’t you know I worry about you when things change?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My meowing makes you smile, but there is something in your smile that angers me. Your eyes seem distant somehow, like you’re smiling at something that isn’t here. Well"), _c('i', [_vm._v(", I")]), _vm._v(" am here. Stop smiling like that. Is it because my voice is as old and worn as this body?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Or do you know something I do not?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This will be my last life with you, Mother. Don’t you know "), _c('i', [_vm._v("that, ")]), _vm._v("at least?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You never answer my questions.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You rarely accept my gifts.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I meow at you, somewhat more pointedly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Hush, Oliver. You worry too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The sound of your voice is sunlight in my heart, even if I know you don’t really understand me. Or if you do, you don’t let on. I want to be annoyed with you, but your old trick always works and you employ it now, as you place breakfast down before me:")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Cream, with all that remains of last night’s bread and fish…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("And ")]), _vm._v("an egg?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You’re spoiling me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shouldn’t you eat that egg? Daisy won’t lay them much longer this winter, and she may be too old to lay again when spring comes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I look up, licking my lips, and mew at you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Don’t worry about me, Ollie. I find I’m not very hungry today.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Well. If you’re sure.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I eat.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It is hard to eat and purr at the same time once one is no longer a kitten, but your knobby hand is still the best touch I’ve ever known. Never once have you struck me or hurt me. How many animals are so lucky? Time has bent your fingers and weakened my bones, and yet here we are, loving each other as we always have…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As we always will.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Why aren’t you eating anything?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Or even sipping tea?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I finish my breakfast and begin grooming—I still have standards, after all—but you are still not eating. Aren’t you hungry? Or… maybe you feel those little needles pricking their warning through the fabric of the day after all.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Explain them to me, Mother. Please. Explain this quiet dread sitting halfway up my spine. Explain.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But you do not explain.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You pick up your favorite teacup and smile sadly, tears suddenly bright in your faded eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“My hand looked beautiful when I held this once, Oliver. And now look.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Your hand is still beautiful. Everything that you are is beautiful. My eyesight may be slowly failing, but I can still see that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What a beautiful cup.” Your thumb caresses the worn blue porcelain delicately as you whisper. “They won’t have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Have what?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The bone china?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Why would anyone take your teacup?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I don’t want—I don’t want anyone else to drink out of it. It won’t mean the same thing to them. I don’t want them to have it!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You suddenly hurl the cup into the fireplace where it shatters with a horrible noise. I am up on the table, back and tail arched, my fur all on end, hissing, before I fully understand what has happened.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You "), _c('i', [_vm._v("broke ")]), _vm._v("it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You love that possession!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Why would you do this?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You pick me up. My tiny heart is beating too fast against your hand. You hold me against your chest and I can feel that your heart is beating hard and fast, too. Your grip is too tight and I want to squirm away, but you’re crying.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sweet Mother. Why are you crying? Why? Are you sad that you shattered your own cup? You didn’t have to do that. Who would take it from you?")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("The woodcutters go back")]), _vm._v(" and forth several times. They always avert their eyes. You pretend not to notice them and they pretend your house does not exist, and I pretend there is not a terror growing in my heart with every passing hour.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Everything you can burn, you burn. One precious thing at a time, even the knitting needles your mate made for you from the very walnut tree that later took her life. How can you burn those?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What you cannot burn, you break if you can, or else hurl out into the yard for the cow and the pig to walk over, to stomp into the mud.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Won’t we need those things?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Weren’t they important for your life?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Why are you using so much wood, Mother? I do not like the woodcutters, but you’re going to need to buy from them soon if you don’t stop….")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Stop!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("That sweater keeps you alive when you go outside in winter!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Stop!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The smoke is awful!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What are you doing?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Why are you doing this?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But you ignore me. All this time together, all these lives, how can you ignore me now? How? Why? Have I done something wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I’m sorry, Mother. Whatever it was, I’m sorry. Just stop! Please? Please stop.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Stop destroying yourself!")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("At least you")]), _vm._v(" do not burn your spell components. As you settle in to a working, I try to settle too, but I am still on edge.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Slowly, my nerves calm as I see what you are making.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The poppet is a work of art.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You’ve always had a hand for them, but there’s something about this one that stands out, almost humming with power. Maybe it’s because every stitch costs your gnarled hands so much pain. Maybe it’s because the tears do not stop falling all the time you sew.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Maybe it’s because you have destroyed nearly everything else you own, and the power of all that destruction flows into the poppet.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This is all you have left; you can devote your whole self to making this poppet. Is that what you are doing? I hope so. Either way, I am proud of you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The young, black-hearted fools of the village have so often been cruel to you. I heard every name they called you. I felt every stone they threw. These people are so self-righteous. They believe such foolish things and believe them so ardently that even a cat such as I must be embarrassed to look at them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This is better, Mother. It is better that you make this poppet. Whose face will you put upon it? Whose name will you stitch into it? The vain young man who leads the cruelty?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It is better that you do not hurt yourself anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Hurt them, if you must hurt someone.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You have never deserved pain at anyone’s hands… including my own claws. I am sorry for scratching you the time you tried to take a goldfinch out of my mouth. But even when you did that, you were gentle. You were always gentle. Your kind soul, your loving heart, your gentle nature. These are the reasons I was sent to you, the reasons the earth chose you as one of her Blessed, the reason the moon smiled upon you when you were young, when you and your mate laughed and danced and spun, skirts flowing out, hair unbraided.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Before the walnut tree.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She was so slender, even the weakest branch would have held her. But they didn’t use the weakest branch, did they?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("How could you forgive them?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I still don’t understand that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They have done you so much harm. Keep working on that poppet. Let at least one of them finally pay for all of this.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("When I see that you are turning the poppet into the village leader, I purr in satisfaction. Yes. This is as it should be. He leads their folly. Let him lead their loss.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("There are very")]), _vm._v(" few noises from the village. The autumn air is almost warm now, the day at its peak. No wind, nothing to stir the trees. Everything is still⁠—")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And so I hear the noises, and the silences between them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I do not hear any cries from children. I do not hear the striking of hammers, the creaking of wheels.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Is no work being done in the village?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("For a while, I heard the hollow impacts of firewood being tossed, all the wood the men brought back this morning, but now there is nothing. A dog barks and is quickly hushed. A horse whinnies. A child calls out and is scolded, worse than the dog.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("People are waiting for something, quiet as animals who sense they are in danger.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What does this mean?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I sit on the porch, tail tapping lightly against the broom leaning by the door; there is a pumpkin in my spot, just as there always is this time of year, or else my perfect tail would not touch the broom.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pumpkins usually give me joy. I like their shapes and smells, like the energy they contain, and something about their texture is particularly nice to bite and claw on occasion, but I am not in the mood for these things right now. Something is too wrong, even if the day is peaceful and beautiful—something to do with that quiet in the village.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("If you won’t investigate it, Mother, I will.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I stand and stretch and, to show that I am not spiteful even if I am irritable, I rub my cheek against the pumpkin’s curled stem. It really is a lovely texture and I could enjoy scratching my face against it all day—but I can’t linger. I have a mission.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("You are")]), _vm._v(" the only one whose words I can understand unless people are speaking about you. Normally this means that a walk through the village is like walking past kittens babbling their nonsense, but not so today.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Today, everyone is speaking of you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Speaking of you—and fearing. Children are being held tightly. Dogs are on alert. Geese are not roaming. The other cats all refuse to meet my gaze, although that last is not necessarily new; they’ve always sensed that I wasn’t like them. Housecats and familiars do not fraternize.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But people do. They are fraternizing now, most gathering in an aimless sort of way, as if they all want something but are afraid to admit it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Always was different,” one human says of you. It has the air of justification.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You know, we just couldn’t get through to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It’s a mercy, really. At her age.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And we have to think of the children.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes, yes. We must always think of the children.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Still,” a woman says with mock empathy, doing such a poor acting job that I want to sink my fangs into her chest and chew until I discover if there was ever a heart in there, “it does seem like a terribly painful way to die.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Die?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My pupils go huge.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A growl rises in my chest but I choke it down. If anyone spots me hiding under the baker’s wagon, they’ll throw stones at me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It is nothing compared to the pain she will face in Hell,” another man says. The leader. Ah, yes. The poppet was a wonderful likeness. Look how his neck juts out in the front, sharper than anyone’s.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“We must do the right thing,” he continues. “We must protect ourselves. It will all be over quickly and then the village will be at peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Now, who is going to help me fetch her?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The leader moves aside as he speaks, revealing a massive pile of firewood that has been stacked in the town square. The pyre has been built around one tall timber still standing upright.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Firewood.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A painful way to die.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Think of the children.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Are they going to…?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No, no, no, no, no!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I don’t wait to see who volunteers to fetch you. I race back to you, running as I have never done before, a streak of blackest lightning on a desperate mission.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("“Oliver. I wondered where you were.”")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You smile so sadly, but you look beautiful, in your old chair on the porch, the pumpkin beside you gleaming in the golden afternoon sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You pat your lap, but I couldn’t jump up even if I wanted to. That run did something to my body. I can feel the strangest sensation, as if there was firelight within me but it is starting to flicker now—a sensation I know well, the beginning of death. Running took more than my body had left, it seems.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I yowl at you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oliver!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You reach to grab me and I can’t help it. I lash out, my claws tearing right through your papery skin. Blood beads and you yelp and I hiss with everything I have in me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What are you doing?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This is no time to sit and watch the day go by.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We have to flee!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oliver,” you sigh. “I know what you want me to do, but don’t you see, my darling? I’m too old to run. Where would I go? My life was here.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("NO!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I knock over the broom as I clumsily leap onto the pumpkin, uncoordinated in my exhaustion. See the broom? Why have you never heeded the dreams I sent you? You don’t have to run, you can "), _c('i', [_vm._v("fly, ")]), _vm._v("I can show you how! I’m supposed to show you, I’m supposed to protect you!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oliver.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You knew!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You sensed the warnings just as I did and you understood them better and so you fed me all of the breakfast and you ruined everything you owned and now you won’t even "), _c('i', [_vm._v("try?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Stop that yowling,” you snap.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I hiss and thrash my tail violently, claws all digging into the pumpkin, releasing its sweet scent. But I stop yowling, as you ordered. My green eyes are fixed on you. I’m not going to forgive you, if that’s what you think. You’re my family, you’re all I have.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You use an old lace handkerchief to dab at the blood, sigh, and look out at your chickens. They’re old, too, like us, and barely lay anymore. Does that mean you won’t fight for them? Are none of us worth it? You won’t "), _c('i', [_vm._v("stay ")]), _vm._v("for any of us? For me?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You don’t understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No, I don’t.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You knew, you had time, and what are you doing now? Sitting and waiting for them? They’re going to burn you! Don’t you understand?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Where is your poppet? At least take one of those bastards out first. One pin is all it will take. You always used your poppets to "), _c('i', [_vm._v("heal, ")]), _vm._v("but you can use them to hurt. Do it, do it now!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Stop yowling, my love. It’s all right. Everything will be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It won’t.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You’ll be gone.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Nothing will be all right.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Who will feed me?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Who will pet me?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Who will understand me?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Who will I send dreams of magic to?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Whose witchcraft will I bless?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Who will love me when you are gone?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I don’t have much time left.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Can’t we steal every last minute?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Why can’t I weep? It isn’t fair that cats can’t cry.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I yowl and yowl. Understand me! Agree with me! Come with me! Let’s run away and "), _c('i', [_vm._v("live, ")]), _vm._v("maybe it’s not too late. This doesn’t have to be the end. You can save my life if you just let me save yours.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Can’t we have more days in the sun, more nights by the fire?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oliver. Sweet Oliver.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No. Not sweet Oliver.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("If you won’t do this, I will.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("If we can’t have a future, then neither will they.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I dart inside, sniff around, and find the poppet—unfinished, set aside. Your anger didn’t last long enough for you to see it through. They’re going to do this to you and you won’t even fight back?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You healed their injured and their ill. You always had a kind word and a patient ear. If someone needed food, you gave them yours. You were wise, gentle, nurturing, everything a witch is supposed to be⁠—")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And they’re going to burn you for it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I won’t let this happen silently.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Not unavenged.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("If all that is left is spite, so be it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I run back out, the poppet hanging from my mouth like a dead rat, and stare up at you defiantly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oliver.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Don’t use that stern tone with me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oliver, give me that.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You reach. I growl⁠—")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And the gate hinges creak. The latch jingles.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They’re here.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We’re out of time.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Your pupils go wide with horror. Anyone else would probably think you’re afraid of the men from the village coming to drag you to the pyre, but I know better. You’re afraid of what I will do.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Get her damned cat,” a man shouts, but I’m already gone, racing away.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("One last race.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("One last errand for my witch.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("If you won’t avenge yourself, Mother, I will do it for you.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("It doesn’t take so very")]), _vm._v(" long to run from house to house. No one is home. They are all going to watch you die.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I slip into every home, needing no more space than a shadow or a nightmare, fury and grief summoning more magic than I have ever been able to call on before.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In every house, I lay down in the kitchen, which is the heart of any home, and drop the poppet between my paws. You would need a spell for this, ingredients and words and time to channel your intent and tie threads into the energy of the homes, but I am what I have always been: magic itself. I do not need the trappings. Only the vessel.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Only the will.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The spite.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Flow into the poppet, all you safe and sturdy and oh-so-respectable houses. Become one with it. Tie your fate to it. Winter approaches and I have no mercy for those who possess none themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Hurry.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("The village square.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I see her. I run to her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To my final death.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Nine lives lived.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I will not be born again. Not this time. There is some fear in that, but I will also never die again. This is the last time.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There is comfort in that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The crowd of dozens seems like thousands. All their hearts are full of hate and every mind closed to reason. How many of them think themselves good people? How many will later claim there was nothing they could do to stop this?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Well, my dear despised townsfolk, let me walk among you with hatred and madness of my own.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The poppet feels heavy and dirty in my mouth. There’s a bitter taste to it now. I do not let go. It is so full of magic that it numbs my jaw, but I will never let go.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I feel the threads spun from it, finer than any spider’s web. They drag it down, threads connecting it to every home⁠—")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Even the one I shared with her.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("Your prayers")]), _vm._v(" for my witch’s soul are ending as I make it to the small clearing around the pyre.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There she is.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("An old woman whose actions were only ever kind, even when she was hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You people have tied her to a stake as if you expect her to run.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fools.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("All of you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Monsters.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Someone starts forward with a torch, some young husband who thinks too often of the children and believes this intolerance is a lesson worth teaching them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I dart past him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He shrieks like a frightened puppy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("People gasp and draw away from me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A few nimble hops and I am next to my mother. My witch. My friend. My fate.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I sit next to her and look up, my jaw heavy and numb from the poppet, from all of that magic, a thread to every house, a vengeance that will be complete the moment these people decide it to be. No one but I can see those threads. I see them glowing, see their promise. They will not fail me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My witch’s eyes shine brightly. The sun is nearly set. It turns her white hair back to the gold of her youth. She is the most beautiful being, just as she has always been.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oliver,” she whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There are new tears on her cheeks. Even if she wishes I had escaped, she takes some comfort in my presence now. She always has.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We gaze into each other’s eyes for the last time, seeing and knowing and loving all that we can about each other. She is kind and I am cruel, but here we are, at the end, and we are perfect for each other.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The pyre reeks of pitch and kerosene.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The people are overcoming their fear.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They feel strong in their numbers. In their righteousness. They have no idea what their actions will bring down upon them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The torchbearer moves closer. He is shouting words about my witch, doubtless vile ones, but I choose not to understand them. I sit primly next to her and wrap my tail around my tiny paws. I still have standards. I will not look desperate where you can see me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I lock eyes with the torchbearer. He looks sickly and sweaty. Pathetic. Afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Do it, you coward.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Burn the woman who is so different from you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Think of the children.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Think of your children. Where will they sleep tonight? Where will any of them find shelter this winter? Your hand shakes as you lower the torch toward the pyre.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It would shake more if you knew.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Flames crackle.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The pyre ignites.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The heat and pain are worse than I thought. They come faster than I imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My witch doesn’t move, and neither do I.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We stare you down until a wall of flame and smoke rise between us, sparing us the sight of you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We rise with that smoke, rise away from our bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My body looks old and frail, too weak for any of the running I did today. I look at it fondly and see the poppet fall free of my fangs⁠—")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And begin to burn.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sparks dance and then the flames take it completely. The moment they do, every house bursts into flame, fire exploding, blasting out windows, cracking chimneys.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Screams begin.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Cries of despair.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shouts for water.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Prayers to heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I have no more need to look.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I float freely into the endlessness, content, beside my witch. She is finally flying.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Your homes will burn to ashes tonight and there is nothing you can do to put out those flames.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It was never the witch you mortals needed to fear. It was me. It was always me, the beast who devoted himself to "), _c('i', [_vm._v("her, ")]), _vm._v("body, heart, and soul. The cat who mirrors whatever cruelty you give, who knows that "), _c('i', [_vm._v("that ")]), _vm._v("is the truth of magic.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The witch’s familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Damn you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Damn you all.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-square"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/bookbrushimage-2024-1-16-12-4725.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("About the Author")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote-container prose without-attribution within-prose-element"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution within-prose-element"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last"
  }, [_vm._v("Lisse Kirk is a queer author dredged up from the depths of Puget Sound. They enjoy long walks on very cold beaches, finding neat rocks in remote places, and writing first drafts by hand while trying not to spill the inkwell. Although they occasionally write stories about animals, most of their books are focused on LGBTQIA+ characters.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab646de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/so-burn-us-both.vue
// module id = 75
// module chunks = 0